import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/ui/card';
import { Badge } from '@shared/ui/badge';
import { Button } from '@shared/ui/button';
import { Building, Mail, Phone, MapPin, Globe, FileText, X } from 'lucide-react';
import { Dialog, DialogContent } from '@shared/ui/dialog';

interface UtilityDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  utility: any
}

const ViewUtilityDetailsModal: React.FC<UtilityDetailsModalProps> = ({
  isOpen,
  onClose,
  utility,
}) => {
  if (!utility) return null;
 console.log("debug utility", utility);
  const detailItems = [
    { icon: Mail, label: 'Email', value: utility.email },
    { icon: Phone, label: 'Phone', value: utility.contactNumber },
    { icon: MapPin, label: 'Address', value: utility.addressMap?.address },
    { icon: MapPin, label: 'City', value: utility.addressMap?.city },
    { icon: MapPin, label: 'State', value: utility.addressMap?.state },
    { icon: Globe, label: 'Website', value: utility.website },
    { icon: FileText, label: 'Tax Registration', value: utility.gstHstNumber },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="border-0 shadow-none min-w-[60vw]">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
          <div className="flex items-center space-x-3">
            <div className=" rounded-md text-primary flex items-center justify-center">
                  {utility?.logo ? (
                    <img
                      src={utility.logo}
                      alt={`${name} logo`}
                      className="h-10 w-10 object-contain"
                    />
                  ) : (
                    <Building className="h-5 w-5" />
                  )}
                </div>
            <div>
              <CardTitle className="text-xl font-semibold">{utility.name}</CardTitle>
              <p className="text-sm text-muted-foreground mt-1">{utility.description}</p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Badge
              variant={utility.isActive ? "default" : "outline"}
              className={utility.isActive 
                ? 'bg-green-100 text-green-700 border border-green-300' 
                : 'bg-gray-100 text-gray-700 border border-gray-300'
              }
            >
              {utility.isActive ? 'Active' : 'Inactive'}
            </Badge>
          </div>
        </CardHeader>
        
        <CardContent className="space-y-6">
          {/* Setup Progress */}
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium">Setup Progress</span>
              <span className="text-sm font-semibold">{utility.setupPercentage}%</span>
            </div>
            <div className="h-2 w-full bg-muted rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500 bg-primary"
                style={{ width: `${utility.setupPercentage}%` }}
              />
            </div>
          </div>

          {/* Contact & Details */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {detailItems.map((item, index) => {
              const Icon = item.icon;
              const hasValue = item.value && item.value.trim() !== '';
              
              return (
                <div key={index} className="flex items-start space-x-3 p-3 rounded-lg border bg-card">
                  <div className="p-1.5 rounded-md bg-muted">
                    <Icon className="h-4 w-4 text-muted-foreground" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground">{item.label}</p>
                    <p className={`text-sm mt-0.5 ${hasValue ? 'text-muted-foreground' : 'text-muted-foreground/60 italic'}`}>
                      {hasValue ? item.value : 'Not provided'}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </DialogContent>
    </Dialog>
  );
};

export default ViewUtilityDetailsModal;